<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
// import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import { rentRecordService } from "../../../../services/managements/rents/rentrecord.service";
import { propertyService } from "../../../../services/managements/propertyservice/property.service";
import { customerService } from "../../../../services/contactservice/customer.service";
import { service } from "../../../../services/managements/services/service";
import moment from 'moment'
import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Request Terminate Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    Select,
    Search,
  },
  data() {
    return {
      dropdownSelection: {},
   
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Request Terminate",
      breadCrumb: {},


      projectData: {},
      propertyData: {},
      customerData: {},
      serviceData: {},
      user: JSON.parse(localStorage.getItem('user')),

      dataProjectId: 1,
      dataLastProjectId: 0,
      dataPropertyId: 0,
      dataPropertyName: '',
      dataCustomerId: 0,
      dataWatterRecord: '',
      dataElectrictRecord: '',
      dataMonthlyBillingDate: 0,
      dataPrice: 0,
      dataStartDate: '',
      dataEndDate: '',
      dataLeaveReason: '',
      dataLastRentRecordId: 0,
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }
  },
 
  methods: {
    loadingData: function(id) {
      this.fetchingStats = true;
      propertyService.getOne(id)
        .then(response => {
          if(id != 0){
            this.dataProjectId = response.data.project_id;
            this.propertyData = response.data;
            this.dataPropertyId = this.propertyData.id
            this.dataPropertyName = this.propertyData.code
            this.dataMonthlyBillingDate = this.propertyData.monthly_billing_date ? this.propertyData.monthly_billing_date : 0
            this.dataCustomerId = response.data.tenant_id;
            this.dataEndDate = this.propertyData.end_rent_date;
            this.dataLastRentRecordId = this.propertyData.last_rent_record_id;
          }
          this.loadingSettings(response.setting);
          this.loadingCustomerData();
          this.loadServiceData();
        });

    },

    loadingSettings: function(setting) {
      this.projectData = {data: setting.projects};
      this.propertyData = {data: setting.properties};


    },

    loadingCustomerData: function() {
      let param = '?page=0';
      customerService.getList(param)
        .then(response => {
          this.customerData = response.data;
        });
    },

    loadServiceData:  function(id, param = '?page=0') {
      service.getList(param)
        .then(response => {
          let currentData = response.data;
          this.serviceData = currentData;
        });
       
    },

    dateFormat: function(value){
      return moment(String(value)).format('YYYY/MM/DD');
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "manage-property"
          });

        }
      });
    
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;


     
      let list = [];
      Object.keys(this.$refs).map(el => {
        // console.log(this.$refs[el]);
        if('getItem' in this.$refs[el][0]) {
          let item = (this.$refs[el][0]).getItem();
          if(item != null && item.check) {
            list.push(item);
          }
        }
      });

      let dataSubmit = {
        project_id : this.dataProjectId,
        property_id : this.dataPropertyId,
        customer_id : this.dataCustomerId,
        updated_by : this.user.id,
        end_date : this.dataEndDate,
        leave_reason: this.dataLeaveReason,
        last_rent_record_id: this.dataLastRentRecordId,
      }

      rentRecordService.requestTerminate(dataSubmit)
        .then(response => {
           this.tryingToSubmit = false;
            console.log(response);
           if(response.status == 200) {
              this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.ok'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-invoice-generate",
                  params:  {id: response.data.property_id},
                });
              }
            });
          }
        });
    },


    clearForm: function() {

      this.dataProperty = 0;

    },

  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader :items="[{
        text: $t('property.text'),
        href: '/manage/property',
      }, {
        text: $t('manage.room-status.terminate-request'),
        active: true
      }]" :title="$t('manage.room-status.terminate-request')" />
    </div>
    

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              
            <div class="row">
                <div class="col-md-4">
                <Select
                  @change="projectChanged" 
                  :id="'project_id'"
                  :disabled="true"
                  v-model="dataProjectId"
                  :list="this.projectData"
                  :label="'property.project'"
                  :require="true"
                    /> 
              </div>
              <div class="col-lg-4">
                <Input 
                  :id="'property_id'"
                  :disabled="true"
                  v-model="dataPropertyName"
                  :label="'property.text'" 
                />
              </div>
              <div class="col-sm">
                  <Search 
                    :text="'name'"
                    :id="'customer_id'"
                    :editable="false"
                    v-model="dataCustomerId"
                    :list="{data: customerData}"
                    :require="true"
                    :label="'customer.text'"  />
              </div>
              <div class="col-lg-4">
                <Input 
                  :id="'end_date'"
                  :type="'date'"
                  :require="true"
                  v-model="dataEndDate"
                  :label="'ថ្ងៃខែចាកចេញ'" 
                />
              </div>
              <div class="col-sm-8">
                <Input 
                  :id="'reason'"
                  v-model="dataLeaveReason"
                  :label="'មូលហេតុចាកចេញ'" 
                />
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-lg-12">

                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>